import { HttpParams } from '@angular/common/http';
import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { ImageCroppedEvent, ImageTransform } from 'ngx-image-cropper';
import { MessageService } from 'primeng/api';
import { EventosI } from 'src/app/interfaces/eventos.interface';
import { TicketI } from 'src/app/interfaces/ticket.interface';
import { UserI } from 'src/app/interfaces/user.interface';
import { TicketService } from 'src/app/pages/home/sub-pages/sections/tickets-generator/services/ticket.service';
import { AuthLoginService } from 'src/app/pages/login/services/auth-login.service';
import { GoalI, GoalService } from 'src/app/services/goal/goal.service';
import {
  AdjuntosI,
  NovedadesService,
} from 'src/app/services/novedades/novedades.service';
import { dataURLtoFile } from 'src/app/tools/tools';
import { environment } from 'src/environments/environment';
import { AgendaService } from '../agenda/agenda.service';
import { DialogComponent } from '../dialog/dialog.component';
import { NavbarService } from './navbar.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent {
  otherAction: any;
  selectedImgDescription!: string;
  selectedImg!: string;
  description!: string;
  id!: string;
  edit!: boolean;
  constructor(
    private readonly auth: AuthLoginService,
    private readonly ticketService: TicketService,
    private readonly goalService: GoalService,
    private readonly novedadesService: NovedadesService,
    private readonly router: Router,
    private readonly service: NavbarService,
    private readonly agendaService: AgendaService,
    private readonly messageService: MessageService
  ) {}
  private user!: UserI | null;

  visible = true;
  goals: GoalI[] = [];
  imgResult!: any;
  visibleUpload = false;

  // * RESPONSIVE
  isMobile = false;
  mobileMenuOpen = false;
  activeOverlay: 'agenda' | 'mensajes' | 'goal' | 'vaca' | null = null;

  imageToEdit!: string;
  canvasRotation = 0;
  transform: ImageTransform = {};
  imageCropped(img: ImageCroppedEvent) {
    const reader = new FileReader();
    reader.onload = (event) => {
      this.imgResult = event.target?.result as string;
    };
    reader.readAsDataURL(img.blob!);
    this.imgResult = img.base64;
  }
  hasNotification = false;

  isProyectos = false;
  prevHasNotification!: any;
  agenda: EventosI[] = [];
  closeNews() {
    this.visibleNews = false;

    if (this.images.length) {
      localStorage.setItem('lastNewsSeen', this.images[0].id!);
    }
  }
  hideDialog() {
    this.visibleUpload = false;
    this.imageToEdit = '';
    this.imgResult = '';
    this.description = '';
    this.id = '';
    this.edit = false;
    this.canvasRotation = 0;
    this.transform = {};
  }
  rotateRight() {
    this.canvasRotation++;
    this.flipAfterRotate();
  }
  private flipAfterRotate() {
    const flippedH = this.transform.flipH;
    const flippedV = this.transform.flipV;
    this.transform = {
      ...this.transform,
      flipH: flippedV,
      flipV: flippedH,
    };
  }
  async addImage(event: any, input: HTMLInputElement) {
    const files = event.target.files;
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.onload = (e) => {
          const imageUrl = e.target!.result !== null ? e.target!.result : '';
          this.imageToEdit = imageUrl.toString();
        };
        reader.readAsDataURL(file);
      }
    }
    input.value = '';
  }
  rotateLeft() {
    this.canvasRotation--;
    this.flipAfterRotate();
  }
  onInsertImage(dialog: DialogComponent) {
    dialog.confirm(
      '¿Esta seguro/a de cargar la siguiente imagen?',
      'Confirmación de carga',
      () => {
        this.submit(dialog);
      }
    );
  }
  submit(dialog: DialogComponent) {
    dialog.start();
    const data = new FormData();
    data.append(
      'file',
      dataURLtoFile(this.imgResult, 'new_image.jpeg', 'image/jpeg')
    );
    const adjunto: AdjuntosI = {
      imagen: '',
      description: this.description,
    };
    data.append('form', JSON.stringify(adjunto));
    this.novedadesService.insertImage(data).subscribe({
      next: (data) => {
        data.imagen = `${environment.imagesUrl}novedades/${data.imagen}`;
        this.images.unshift(data);
        dialog.stop(
          '¡La imagen se cargó con éxito!',
          'Confirmación de carga',
          () => {
            this.visibleUpload = false;
          }
        );
      },
      error: (e) => {
        console.error(e);
        dialog.stop(
          'Ocurrió un error durante la carga',
          'Error de carga',
          () => {},
          false
        );
      },
    });
  }
  onEditImage(dialog: DialogComponent) {
    dialog.confirm(
      '¿Esta seguro/a de editar la siguiente imagen?',
      'Confirmación de carga',
      () => {
        this.editImage(dialog);
      }
    );
  }
  editImage(dialog: DialogComponent) {
    dialog.start();
    const data = new FormData();
    data.append(
      'file',
      dataURLtoFile(this.imgResult, 'new_image.jpeg', 'image/jpeg')
    );
    const adjunto: AdjuntosI = {
      imagen: '',
      description: this.description,
    };
    data.append('form', JSON.stringify(adjunto));
    this.novedadesService.updateImage(this.id, data).subscribe({
      next: (data) => {
        const img = this.images.find((item) => item.id === this.id);
        if (img) {
          img.imagen = `${environment.imagesUrl}novedades/${data.imagen}`;
          img.description = this.description;
        }
        dialog.stop(
          '¡La imagen se modificó con éxito!',
          'Confirmación de carga',
          () => {
            this.visibleUpload = false;
          }
        );
      },
      error: (e) => {
        console.error(e);
        dialog.stop(
          'Ocurrió un error durante la carga',
          'Error de carga',
          () => {},
          false
        );
      },
    });
  }

  onDeleteImage(dialog: DialogComponent) {
    dialog.confirm(
      '¿Esta seguro/a de eliminar la siguiente imagen?',
      'Confirmación de carga',
      () => {
        this.deleteImage(dialog);
      }
    );
  }

  deleteImage(dialog: DialogComponent) {
    dialog.start();
    const data = new FormData();
    const adjunto: AdjuntosI = {
      description: this.description,
      active: false,
    };
    data.append('form', JSON.stringify(adjunto));
    this.novedadesService.updateImage(this.id, data).subscribe({
      next: (data) => {
        this.images = this.images.filter((item) => item.id !== this.id);
        dialog.stop(
          '¡La imagen se eliminó con éxito!',
          'Confirmación de carga',
          () => {
            this.visibleUpload = false;
          }
        );
      },
      error: (e) => {
        console.error(e);
        dialog.stop(
          'Ocurrió un error durante la carga',
          'Error de carga',
          () => {},
          false
        );
      },
    });
  }

  async ngOnInit() {
    const userState = await this.auth.returnUserInfoV2('LOADED');

    if (!userState) return;

    this.user = userState.user;

    this.isProyectos = (this.user?.lob?.some((i) => i.name === 'Proyectos') ||
      this.user?.superuser)!;

    let params = new HttpParams();

    if (!this.user?.superuser)
      params = params.set('upload_user', this.user?.id!);

    this.getTicketsNotification(params);
    this.getNovedades();

    //! Nos suscribimos a este observable solo para cambiar el estado de las notificaciones.
    this.service.changeState$.subscribe((state) => {
      if (state) this.getTicketsNotification(params);
    });

    this.service.visible$.subscribe((data) => {
      this.visible = data;
    });

    if (this.isProyectos) {
      const { lunes, domingo } = this.obtenerFechasLunesADomingo();
      const lob = 'Proyectos';
      const user = this.user?.id;
      let params = new HttpParams();
      params = params.set('lob', lob);
      params = params.set('usuario', user!);
      params = params.set('desde', lunes.toDateString());
      params = params.set(
        'hasta',
        new Date(domingo.setDate(domingo.getDate() + 1)).toDateString()
      );
      this.agendaService.getAgenda(params).subscribe((data) => {
        this.agenda = data;
      });
    }
    this.goalService.getAll().subscribe({
      next: (data) => {
        this.goals = data;
      },
      error: (e) => {
        console.error(e);
      },
    });
    this.startPolling();
    this.checkMobile();
  }
  startPolling() {
    setInterval(() => {
      let params = new HttpParams();
      if (!this.user?.superuser) {
        params = params.set('upload_user', this.user?.id!);
      }

      this.getTicketsNotification(params);
    }, 5000);
  }
  insertGoal(goal: GoalI[]) {
    this.goalService.insert(goal).subscribe({
      next: (data) => {
        console.info('Cambio de parámetros en Dashboard');
      },
      error: (e) => {
        console.error(e);
      },
    });
  }
  images: AdjuntosI[] = [];
  visibleNews = false;

  getNovedades() {
    this.novedadesService.getImages().subscribe((data) => {
      this.images = data.map((img) => ({
        ...img,
        imagen: `${environment.imagesUrl}novedades/${img.imagen}`,
      }));

      if (!this.images.length) return;

      const ultima = this.images[0]; // vienen ordenadas por fecha

      const ultimaVista = localStorage.getItem('lastNewsSeen');

      if (ultimaVista !== ultima.id) {
        // this.visibleNews = true;
      }
    });
  }
  showImgContainer(img: string, description: string, div: HTMLDivElement) {
    if (!this.otherAction) {
      this.selectedImg = img;
      this.selectedImgDescription = description;
      div.classList.remove('hide-img-container');
    }
    this.otherAction = false;
  }
  navigate() {
    this.router.navigate(['/home/settings']);
  }
  private showedInitialWarning = false;
  private initialized = false;
  getTicketsNotification(params: HttpParams) {
    this.ticketService.getAlltickets(params).subscribe({
      next: (data) => {
        if (data.result) {
          const entities = data.result.entities as TicketI[];

          entities.forEach((t: any) => {
            // 🆕 NUEVO TICKET
            const esNuevoTicket =
              t.open_date === null &&
              String(t.upload_user?.id) !== String(this.user?.id) &&
              !this.seenTickets.has(t.id);

            if (this.initialized && esNuevoTicket) {
              this.messageService.add({
                severity: 'success',
                summary: '🎫 Nuevo ticket',
                detail: `Se creó el ticket #${t.id_visible}`,
                life: 5000,
              });
            }

            this.seenTickets.add(t.id); // 👈 SIEMPRE lo marcás como visto

            // 💬 RESPUESTAS
            t.responses?.forEach((r: any) => {
              const responseId = `${t.id}_${r.id}`;

              const esNuevaRespuesta =
                r.open_date === null &&
                String(r.upload_user?.id) !== String(this.user?.id) &&
                !this.seenResponses.has(responseId);

              if (this.initialized && esNuevaRespuesta) {
                this.messageService.add({
                  severity: 'info',
                  summary: '💬 Nueva respuesta',
                  detail: `${r.upload_user.full_name} respondió el ticket #${t.id_visible}`,
                  life: 5000,
                });
              }

              this.seenResponses.add(responseId); // 👈 SIEMPRE guardar
            });
          });

          // 🔴 detecta si hay pendientes (viejos o nuevos)
          this.hasNotification = entities.some(
            (t) =>
              t.status !== 2 &&
              ((t.open_date === null && t.upload_user?.id !== this.user?.id) ||
                t.responses?.some(
                  (r) =>
                    r.open_date === null && r.upload_user.id !== this.user?.id
                ))
          );

          // 🟡 PRIMERA VEZ → mostrar SOLO 1 aviso general
          if (
            !this.initialized &&
            this.hasNotification &&
            !this.showedInitialWarning
          ) {
            this.messageService.add({
              severity: 'warn',
              summary: '📌 Tenés pendientes',
              detail: 'Hay tickets sin leer. Revisalos cuando puedas.',
              life: 6000,
            });

            this.showedInitialWarning = true;
          }

          // 👉 marcar inicialización
          if (!this.initialized) {
            this.initialized = true;
          }

          // 👇 IMPORTANTE
          this.initialized = true;
        }
      },
      error: (e) => {
        console.error(e);
      },
    });
  }
  private seenTickets = new Set<number>();
  private seenResponses = new Set<string>();
  private prevCount = 0;

  today = 0;

  obtenerFechasLunesADomingo(): { lunes: Date; domingo: Date } {
    const fechaActual = new Date();

    // Normalizar a medianoche
    fechaActual.setHours(0, 0, 0, 0);

    const diaActual = fechaActual.getDay(); // 0 (Domingo) a 6 (Sábado)
    const offsetLunes = diaActual === 0 ? -6 : 1 - diaActual;

    const lunes = new Date(fechaActual);
    lunes.setDate(fechaActual.getDate() + offsetLunes);
    lunes.setHours(0, 0, 0, 0); // Asegurar que esté a las 00:00:00

    const domingo = new Date(lunes);
    domingo.setDate(lunes.getDate() + 6);
    domingo.setHours(23, 59, 59, 999); // Final del día domingo

    return { lunes, domingo };
  }

  show = false;
  showGoal = false
  vacaMuerta = false

  @HostListener('window:resize')
  onResize(): void {
    this.checkMobile();
  }

  private checkMobile(): void {
    this.isMobile = window.innerWidth <= 768;
    if (!this.isMobile) {
      this.mobileMenuOpen = false;
    }
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
    if (!this.mobileMenuOpen) {
      this.activeOverlay = null;
    }
  }

  toggleOverlay(overlay: 'agenda' | 'mensajes' | 'goal' | 'vaca') {
    this.activeOverlay = this.activeOverlay === overlay ? null : overlay;
  }

  addDays(date: Date, plus: number) {
    return new Date(date.setDate(date.getDate() + plus));
  }

  dias = [
    'Lunes',
    'Martes',
    'Miércoles',
    'Jueves',
    'Viernes',
    'Sábado',
    'Domingo',
  ];
}
